import { render, staticRenderFns } from "./CareServiceList.vue?vue&type=template&id=6dff6342&scoped=true"
import script from "./CareServiceList.vue?vue&type=script&lang=js"
export * from "./CareServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dff6342",
  null
  
)

export default component.exports